/**
 * GA4 イベント計測のスキーマ定義 (TypeScript 側)
 *
 * バックエンド側 `rfcommon.models.analytics` と値が同期している必要がある。
 * enum 追加・変更時は両側を必ず更新する。
 */

export const EventName = {
  spot_interaction: "spot_interaction",
  view_spot_detail: "view_spot_detail",
  request_recommendation: "request_recommendation",
  toggle_line_delivery: "toggle_line_delivery",
  page_view: "page_view"
} as const;
export type EventName = (typeof EventName)[keyof typeof EventName];

export const Source = {
  web: "web",
  line: "line"
} as const;
export type Source = (typeof Source)[keyof typeof Source];

export const InteractionType = {
  saved: "saved",
  visited: "visited",
  disliked: "disliked"
} as const;
export type InteractionType = (typeof InteractionType)[keyof typeof InteractionType];

export const ActionType = {
  create: "create",
  cancel: "cancel"
} as const;
export type ActionType = (typeof ActionType)[keyof typeof ActionType];

/**
 * interaction_method の値は `@/constants/swipeConstants.ts` の `InteractionMethod` 型を
 * 共有する。フロントエンドでは既存型をそのまま使うため、ここでは再定義しない。
 * バックエンド側 enum との同期は `rfcommon.models.analytics.InteractionMethod` を参照。
 */

export const ViewType = {
  instagram: "instagram",
  google_map: "google_map",
  tiktok: "tiktok",
  x: "x",
  official_site: "official_site",
  youtube: "youtube"
} as const;
export type ViewType = (typeof ViewType)[keyof typeof ViewType];
